import URL from '../url'
import Request from '../request'

export const listWorkspaceMembersService = (shopId) =>
  new Request(
    URL.API,
    URL.WORKSPACE_MEMBERS.replace('{shopId}', shopId),
  ).get()

export const inviteWorkspaceMemberService = (shopId, data) =>
  new Request(
    URL.API,
    URL.WORKSPACE_MEMBER_INVITE.replace('{shopId}', shopId),
  ).post(data)

export const updateWorkspaceMemberPermissionsService = (shopId, userId, data) =>
  new Request(
    URL.API,
    URL.WORKSPACE_MEMBER_PERMISSIONS.replace('{shopId}', shopId).replace('{userId}', userId),
  ).put(data)

export const deleteWorkspaceMemberService = (shopId, userId) =>
  new Request(
    URL.API,
    URL.WORKSPACE_MEMBER_DELETE.replace('{shopId}', shopId).replace('{userId}', userId),
  ).delete()

export const revokeWorkspaceInvitationService = (shopId, email) =>
  new Request(
    URL.API,
    URL.WORKSPACE_MEMBER_REVOKE_INVITE.replace('{shopId}', shopId) +
      '?email=' +
      encodeURIComponent(email),
  ).delete()

export const listWorkspacePermissionPresetsService = (shopId) =>
  new Request(
    URL.API,
    URL.WORKSPACE_PERMISSION_PRESETS.replace('{shopId}', shopId),
  ).get()

export const acceptWorkspaceInvitationService = (code) =>
  new Request(
    URL.API,
    URL.WORKSPACE_INVITE_ACCEPT + '?code=' + encodeURIComponent(code),
  ).post()
